<template>
    <div>
      <div v-if="isLoading" class="loader-overlay">
      <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>
        <div class="container-fluid">
            <div class="llp-container-section heightcontainer">
                <top-header id="height2"></top-header>
                <main-menu id="height3"></main-menu>
            <div class=" menu-margin-top">
                <div class="searchBlock row pb-4 px-3 ml-0">
                 <div class="col-sm-12 mt-3 mb-4">
                        <ul class="navLinks">
                            <li>
                                <router-link :class="{ active: isActiveRoute('/mergeDealer') }" class="linkItem" to="/mergeDealer">Duplicate Dealers</router-link>
                            </li>
                            <li>
                                <router-link :class="{ active: isActiveRoute('/mergedDealersList') }" class="linkItem" to="/mergedDealersList">Merged Dealers</router-link>
                            </li>
                            <li>
                                <router-link :class="{ active: isActiveRoute('/dealerActivityLog') }" class="linkItem" to="/dealerActivityLog">Activity Log</router-link>
                            </li>
                        </ul>
                    </div>
                  <div class="col-sm-12 mb-4">
                      <h3>Merge Duplicate Dealers</h3>
                  </div>
                  <!-- <div class="col-lg-3 col-xl-2"> -->
                  <div class="col-lg-2">
                      <label for="dealerName">Dealer Name</label>
                      <input name='dealerName' type="text" 
                      placeholder="Dealer Name"
                      v-model="searchObj.dealerName"
                      autocomplete="off">
                  </div>
                  <div class="col-lg-2">
                      <label for="fname">First Name</label>
                      <input name='fname' type="text" 
                      placeholder="First Name"
                      v-model="searchObj.firstName"
                      autocomplete="off">
                  </div>
                  <div class="col-lg-2">
                      <label for="lname">Middle Name</label>
                      <input name='mname' type="text" 
                      placeholder="Middle Name"
                      v-model="searchObj.middleName"
                      autocomplete="off">
                  </div>
                  <div class="col-lg-2">
                      <label for="lname">Last Name</label>
                      <input name='lname' type="text" 
                      placeholder="Last Name"
                      v-model="searchObj.lastName"
                      autocomplete="off">
                  </div>
                  <!-- <div class="col-lg-3 col-xl-2"> -->
                  <div class="col-lg-2">
                      <label for="email">Email</label>
                      <input name='email' type="email" 
                      placeholder="Email"
                      v-model="searchObj.email"
                      autocomplete="off"
                      >
                  </div>
                  <!-- <div class="col-lg-3 col-xl-2"> -->
                  <div class="col-lg-2">
                      <label for="mobile">Office Number</label>
                      <input name='mobile' type="text" 
                      placeholder="Office Number"
                      v-model="searchObj.OfficeNumber"
                      autocomplete="off"
                      maxlength="14"
                      minlength="10"
                      @input="searchObj.OfficeNumber = $event.target.value.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')"
                      >
                  </div>
                  <!-- <div class="col-lg-3 col-xl-2 btncontainer"> -->
                  <div class="col-lg-2 btncontainer">
                      <button  @click="searchDealerDebounce()"
                      :disabled ="searchButtonDisable()">
                        Search
                      </button>
                  </div>
                  <div class="col-md-12 col-xl-12">
                      <p class="clearText"><a type="button" 
                      @click="clearSearch()"
                      >Clear Search</a></p>
                  </div>
                </div>
                <div class="row tableContainer pt-5 pb-4 px-3 ml-0">
                  <div class="col-md-4 col-xl-7">
                    <h3>Dealers List</h3>
                  </div>
                  <div class="col-md-5 col-xl-3 d-flex justify-content-end">
                    <!-- <div>
                    <label for="" class="filterLabel">Filter</label>
                    </div> -->
                    <div class="dropdownContainer">
    <b-dropdown id="dropdown-form" :text="''" ref="dropdown" class="filterDropdown" toggle-class="dropdownToggle">
      <template #button-content>
          <div class="d-flex flex-wrap">
            <span v-if="selectedOptions.length === 0">Select Filters</span>
            <span v-for="(option, index) in selectedOptions" :key="index" class="chip">
              {{ option }}
              <b-button size="sm" class="ml-2 p-0 btnChip" @click.stop="removeOption(option)">
                &times;
              </b-button>
            </span>
          </div>
        </template>
        <b-form-checkbox  v-model="filterOptions.primaryContact">Primary Contact Name</b-form-checkbox>
        <b-form-checkbox  v-model="filterOptions.dealerName">Dealer Name</b-form-checkbox>
        <!-- <b-form-checkbox  v-model="filterOptions.middleName">Middle Name</b-form-checkbox>
        <b-form-checkbox  v-model="filterOptions.lastName">Last Name</b-form-checkbox> -->
        <b-form-checkbox  v-model="filterOptions.email">Email</b-form-checkbox>
        <b-form-checkbox  v-model="filterOptions.OfficeNumber">Office Number</b-form-checkbox>
    </b-dropdown>
  </div>
                  </div>
                  <div class="col-md-3 col-xl-2">
                    <button class="mergeButton"
                    @click="confirmMerge"
                    :disabled="this.selectedPrimary.length<=0 || selectedSecondary.length<=0"
                    >Merge Selections</button>
                  </div>
                  <div class="col-12">
                    <table class="table table-responsive-sm mt-4 customerTable">
                      <thead class="tableHeading">
                        <tr>
                          <th style="width:10%">Dealer Id</th>
                          <th style="width:30%">Dealer Name</th>
                          <th style="width:20%">Primary Contact Name</th>
                          <th style="width:20%">Email</th>
                          <th style="width:20%">Office Number</th>
                          <th style="width:10%">Date of Creation</th>
                          <th style="width:10%">Dealers to Keep</th>
                          <th style="width:10%">Dealers to Merge</th>
                          <!-- <th style="width:14%">Action</th> -->
                        </tr>
                      </thead>
                      <template>
                      <tbody v-if="dealerList.length>0">
                        <tr v-for="(dealer,index) of dealerList" :key="dealer.dealerId" :class="{
                          'dark-border': isNewFirstName(index)}">
                          <td class="tableCustomerId align-middle">{{dealer.dealerId}}</td>
                          <td class="second align-middle">{{dealer.dealerName}}</td>
                          <td class="tableName align-middle">{{dealer.firstName !==null ? dealer.firstName : '' }} {{dealer.middleName !==null ? dealer.middleName : ''}}  {{ dealer.lastName !==null ? dealer.lastName : ''}}</td>
                          <td class="tableEmail align-middle">{{dealer.digitalContactInfo.email}}</td>
                          <td class="tableMobile align-middle">{{dealer.digitalContactInfo.workNumber 
                          ? dealer.digitalContactInfo.workNumber.replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3') 
                           : '' }}</td>
                          <td class="tableDate align-middle">{{dealer.createdDate}}</td>
                          <td class="text-center align-middle">
                            <input  type="checkbox" id="keep" 
                            v-model="selectedPrimary" 
                            :value="dealer.dealerId"
                            @change="handleKeepChange(index)"
                            :disabled="primaryColumnDisabled && !selectedPrimary.includes(dealer.dealerId) || selectedSecondary.includes(dealer.dealerId)"
                            >
                          </td>
                          <td class="text-center align-middle">
                            <input  type="checkbox" id="merge"
                            v-model="selectedSecondary" 
                            :value="dealer.dealerId"
                            :disabled="selectedPrimary.includes(dealer.dealerId)"
                            >
                          </td>
                          <!-- <td><button></button></td> -->
                        </tr>
                      </tbody>
                      <tbody v-else class="text-center">
                        {{noResult}}
                      </tbody>
                      </template>

                    </table>
                  </div>
                </div>
              </div>
              <div class="mt-5 mb-5 pb-3">
                    <b-pagination align="center" v-if="rows>perPage && dealerList.length>0"
                     v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    first-number
                    last-number
                    @input="pagination"
                    class="customPagination"
                    ></b-pagination>
                </div>
                <!--confirm merge dealer-->
        <div @click.self="isMergeConfirm = false" v-if="isMergeConfirm" class="modal" id="mergeSelect">
          <div class="modal-content">
            <div class="modal-heading">
              <h4>Merge Dealers</h4>
            </div>
            <div class="modal-body">
              <img src="../assets/question.jpg" alt="" class="logo mt-2" />
              <p class="modalText mt-3 mb-4">
                Are you sure, Do you want to merge dealers ?
              </p>
              <!-- <img src="../assets/question.jpg" alt=""> -->
              <div class="d-flex justify-content-center mt-2 mb-1">
              <button
                type="button"
                class="btn mergeButton mx-2"
                @click="merge()"
              >
                Merge
              </button>
              <button type="button" @click="isMergeConfirm = false"  class="btn yesButton mx-2">Cancel</button>
              </div>
              
            </div>
          </div>
        </div>
        <!--confirm merge dealer-->
        <!--successful merge dialog code start-->
        <div v-if="isSuccess" class="modal" id="successModal" @click.self="closeSuccess()">
          <div class="modal-content">
            <div class="modal-body">
              <img src="../assets/checkicon-min.png" alt="" class="logo" />
              <p class="modalText">
              {{mergeSuccess}}
              </p>
            </div>
          </div>
        </div>
        <!--successful merge dialog code end-->
            <bottom-footer></bottom-footer>
            </div>
        </div>
    </div>
</template>
<script>
import TopHeader from "@/components/TopHeader.vue";
import MainMenu from "@/components/Menu.vue";
import BottomFooter from "@/components/BottomFooter.vue";
import httpcommon from "../js/http-common.js";
import moment from 'moment';


export default {
  components: {
    MainMenu,
    TopHeader,
    BottomFooter,
  },
  name: "mergeDealerData",

data() {
  return {
    selectedPrimary: [],
    selectedSecondary: [],
    mergeDisabled: [],
    searchObj : {
        dealerName: '',
        firstName: '',
        middleName: '',
        lastName: '',
        email: '',
        OfficeNumber: ''
        },
    dealerList: [],
    currentPage: 1,
    rows: 0,
    perPage: 10,
    isMergeConfirm: false,
    isLoading: false,
    isSuccess: false,
    mergeSuccess: '',
    noResult: '',
    isSearch: false,
    filterOptions: {
    dealerName: false,
    primaryContact: false,
    email: false,
    OfficeNumber: false,
    isClearingFilters: false,
    },
    isResponse: false
  }
},
watch: {
    searchObj: {
      handler(newVal) {
        // if (newVal.mobile && !/^\d{0,10}$/.test(newVal.mobile)) {
        //   this.searchObj.mobile = newVal.mobile.replace(/\D/g, '');
        //   return; 
        // }
        const allFieldsCleared = !newVal.dealerName.trim() &&
                                 !newVal.firstName.trim() &&
                                 !newVal.middleName.trim() &&
                                 !newVal.lastName.trim() &&
                                 !newVal.email.trim() &&
                                 !newVal.OfficeNumber ;

        const isMobileNumeric = newVal.OfficeNumber.trim() ? /^\d*$/.test(newVal.OfficeNumber.trim()) : true;

      if (allFieldsCleared && this.isSearch) {
        this.selectedPrimary = []
        this.selectedSecondary = []
        this.currentPage = 1
        this.getDealerList();
      }else if (!isMobileNumeric) {
        // Prevent calling getDealerList if mobile field has non-numeric input
        return;
      } }, // Adjust the debounce delay as needed
      deep: true,
    },

    filterOptions: {
      handler () {
        if (!this.isClearingFilters) {
        this.currentPage = 1
        this.selectedPrimary = []
        this.selectedSecondary = []
        this.getDealerList()
        }
      },
      deep: true
    }
  },
computed: {
  primaryColumnDisabled () {
      return this.selectedPrimary.length>0
    },
    selectedOptions() {
      return Object.keys(this.filterOptions)
        .filter(key => this.filterOptions[key])
        .map(key => this.formatOptionLabel(key));
    }
},
methods: {
  formatOptionLabel(key) {
      const labels = {
        dealerName: 'Dealer Name',
        primaryContact: 'Primary Contact Name',
        email: 'Email',
        OfficeNumber: 'Office Number'
      };
      return labels[key];
    },
    removeOption(option) {
      const key = Object.keys(this.filterOptions).find(key => this.formatOptionLabel(key) === option);
      if (key) {
        this.filterOptions[key] = false;
      }
    },
  handleKeepChange(index) {
    // console.log(this.selectedPrimary[index],'selectedPrimary')
      if (this.selectedPrimary.includes(this.dealerList[index].dealerId)) {
        // Uncheck the checkbox and re-enable all
        this.disableSecondaryColumn(index)
      }
    },
    clearFilterOptions() {
    this.filterOptions.primaryContact = false;
    this.filterOptions.dealerName = false;
    this.filterOptions.email = false;
    this.filterOptions.OfficeNumber = false;

    // Reset the flag after clearing
    this.$nextTick(() => {
        this.isClearingFilters = false;
    });
},
    disableSecondaryColumn (index) {
      const Id = this.dealerList[index].dealerId
      const secondaryIndex = this.selectedSecondary.indexOf(Id)
      if(secondaryIndex > -1) {
        this.selectedSecondary.splice(secondaryIndex,1)
      }
    },
    confirmMerge () {
      this.isMergeConfirm = true
    },
    merge () {
      let mergeData = {
        dealerToKeepId: this.selectedPrimary[0],
        dealersToMergeIDs: this.selectedSecondary,
        dealerToKeep: {
        firstName: "",
        middleName: "",
        lastName: "",
        digitalContactInfo: {
            email: "",
            mobileNumber: ""
          }
        }}
      httpcommon
      .put('/managesource/mergeDealers',mergeData)
      .then(response=>{
        this.isMergeConfirm = false
        this.isSuccess = true
        this.mergeSuccess = response.data
        setTimeout(()=>{this.isSuccess=false
          this.clearSearch()
          this.getDealerList()
        },2000)
        this.selectedPrimary = []
        this.selectedSecondary = []
        // this.clearSearch()
      }).catch(error=>{
        console.log(error,'error')
      })
    },

    searchDealerDebounce () {
      this.currentPage = 1
      this.selectedPrimary = []
      this.selectedSecondary = []
      this.isClearingFilters = true;  // Set the flag before clearing filters
      this.clearFilterOptions(); 
      this.searchDealer()
    },
    
  searchDealer () {
    this.isLoading = true
    this.noResult = ''
    let searchParams = new URLSearchParams();
  if (this.searchObj.dealerName) {
    searchParams.append('dealerName', this.searchObj.dealerName);
  }
  if (this.searchObj.firstName) {
    searchParams.append('firstName', this.searchObj.firstName);
  }
  if (this.searchObj.middleName) {
    searchParams.append('middleName', this.searchObj.middleName);
  }
  if (this.searchObj.lastName) {
    searchParams.append('lastName', this.searchObj.lastName);
  }
  if (this.searchObj.email) {
    searchParams.append('email', this.searchObj.email);
  }
  if (this.searchObj.OfficeNumber) {
    searchParams.append('workNumber', this.searchObj.OfficeNumber.replace(/\D/g, ''));
  }
    this.dealerList = []
    httpcommon
    .get(`/managesource/filterDealerList?${searchParams.toString()}&page=${this.currentPage-1}&size=${this.perPage}`)
    .then(response=>{
      this.isLoading = false
      this.isSearch = true
      if (response.data.content.length>0) {
      this.dealerList = response.data.content
      
      this.dealerList.forEach(dealer=>{
        dealer.createdDate = moment(dealer.creationD).format('Do MMM, YYYY');
      })
      this.rows = response.data.totalElements
      } else {
        this.noResult = 'No Result Found'
      }
    }).catch(error=>{
      this.isLoading = false
      this.errorslist.push(error)
    })
  },
  clearSearch () {
    const isSearch = this.searchObj.dealerName== '' && this.searchObj.firstName== '' && this.searchObj.middleName == '' && this.searchObj.lastName == '' && this.searchObj.email== '' && this.searchObj.OfficeNumber== ''
      if (!isSearch) {
      this.searchObj.dealerName = '',
      this.searchObj.firstName = '',
      this.searchObj.middleName = '',
      this.searchObj.lastName = '',
      this.searchObj.email = '',
      this.searchObj.OfficeNumber= ''
      // this.dealerList = []
      this.currentPage = 1
      this.noResult = ''
      this.selectedPrimary = []
      this.selectedSecondary = []
      // this.getDealerList()
      }
    },
  searchButtonDisable () {
      // return  (!this.searchObj.firstName.trim() && !this.searchObj.middleName.trim() && !this.searchObj.lastName.trim() && !this.searchObj.email && !this.searchObj.mobile)
  //     const allFieldsEmpty = !this.searchObj.firstName.trim() && 
  //                        !this.searchObj.middleName.trim() && 
  //                        !this.searchObj.lastName.trim() && 
  //                        !this.searchObj.email.trim() && 
  //                        !this.searchObj.mobile.trim();
  
  // const isEmailValid = this.searchObj.email.trim() ? this.isValidEmail() : true;
  
  // const isMobileValid = /^\d{10}$/.test(this.searchObj.mobile.trim());
  // return allFieldsEmpty || !isEmailValid || !isMobileValid;
  const isDealerNameFilled = this.searchObj.dealerName.trim() !== '';
  const isFirstNameFilled = this.searchObj.firstName.trim() !== '';
  const isMiddleNameFilled = this.searchObj.middleName.trim() !== '';
  const isLastNameFilled = this.searchObj.lastName.trim() !== '';

// Check if the email is valid or if it's empty
  const isEmailValid = this.searchObj.email.trim() ? this.isValidEmail() : true;

  // Check if the mobile field is valid (only numeric and 10 digits long) or if it's empty
  const isMobileValid = this.searchObj.OfficeNumber.trim() ? /^\d{10}$/.test(this.searchObj.OfficeNumber.trim().replace(/\D/g, '')) : true;

  // Disable the button if all fields are empty, or if email/mobile are invalid
  const isAnyFieldFilled = isDealerNameFilled || isFirstNameFilled || isMiddleNameFilled || isLastNameFilled || this.searchObj.email.trim() || this.searchObj.OfficeNumber.trim();

  return !isAnyFieldFilled || !isEmailValid || !isMobileValid;
  },
  isValidEmail() {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(this.searchObj.email.trim());
    },
    isValidMobile() {
      if(this.searchObj.OfficeNumber) {
      const mobilePattern = /^[0-9]{10}$/; // Adjust the regex according to the required format
      return mobilePattern.test(this.searchObj.OfficeNumber);
      }
    },
  getDealerList () {
    this.isSearch = false
    this.isLoading = true
    this.dealerList = []
    this.noResult = ''
    this.searchObj.dealerName= '',
    this.searchObj.firstName = '',
    this.searchObj.middleName = '',
    this.searchObj.lastName = '',
    this.searchObj.email = '',
    this.searchObj.OfficeNumber= ''
    let filterParams = new URLSearchParams()
    if (this.filterOptions.dealerName) {
      filterParams.append('dealerName',true)
    }
    if (this.filterOptions.primaryContact) {
      filterParams.append('firstName',true)
      filterParams.append('middleName',true)
      filterParams.append('lastName',true)
    }
    
    if (this.filterOptions.email) {
      filterParams.append('email',true)
    }
    if (this.filterOptions.OfficeNumber) {
      filterParams.append('workNumber',true)
    }
    let anySelected = false
    for(const [key,value] of Object.entries(this.filterOptions)) {
      if(value==true) {
        anySelected = true
      }
    }
    if (!anySelected) {
      filterParams.append('dealerName',true)
      filterParams.append('email',true)
    }
    httpcommon.get(`/managesource/getAllDealerList?${filterParams}&page=${this.currentPage-1}&size=${this.perPage}`).then(response=>{
      this.isLoading = false
      if (response.data.content.length>0) {
        this.isResponse = true
      this.dealerList = response.data.content
      this.dealerList.forEach(dealer=>{
        dealer.createdDate = moment(dealer.creationD).format('Do MMM, YYYY');
      })
      
      this.rows = response.data.totalElements

      } else if(!anySelected && response.data.content.length<=0) {

        this.dealerList = []
        this.isLoading = true
        filterParams.delete('dealerName')
        filterParams.append('firstName',true)
        httpcommon.get(`/managesource/getAllDealerList?${filterParams}&page=${this.currentPage-1}&size=${this.perPage}`).then(res=>{
        this.isLoading = false

        if(res.data.content.length>0) {

            this.dealerList = res.data.content
            this.dealerList.forEach(dealer=>{
            dealer.createdDate = moment(dealer.creationD).format('Do MMM, YYYY');
      })
      this.rows = res.data.totalElements
          }
        }).catch(error=>{
      this.isLoading = false
      this.errorslist.push(error)
    })
      }
    }).catch(error=>{
      this.isLoading = false
      this.errorslist.push(error)
    })
  },
  pagination () {
    const checkProp = !this.searchObj.dealerName.trim() && !this.searchObj.firstName.trim() && !this.searchObj.middleName.trim() && !this.searchObj.lastName.trim() && !this.searchObj.email.trim() && !this.searchObj.OfficeNumber.trim()
    if (!checkProp && this.isSearch) {
      this.searchDealer()
    } else {
      this.getDealerList()
    }
  },
  isNewFirstName(index) {
      // if (index === 0) return true; // Always apply border for the first row
      const currentDealer = this.dealerList[index];
      const previousDealer = this.dealerList[index - 1];
      if (!currentDealer || !previousDealer) return false;

       const anySelected = Object.values(this.filterOptions).some(value => value === true);

  if (!anySelected && this.isResponse) {
    // If no filters are selected, only compare by firstName
    // console.log(currentDealer.dealerName !== previousDealer.dealerName)
    // return currentDealer.dealerName !== previousDealer.dealerName;
    return currentDealer.dealerName !== previousDealer.dealerName && currentDealer.digitalContactInfo.email !== previousDealer.digitalContactInfo.email
    
  } else if (!anySelected && !this.isResponse) {
      return currentDealer.firstName !== previousDealer.firstName && currentDealer.digitalContactInfo.email !== previousDealer.digitalContactInfo.email
  }
// if(this.filterOptions.firstName)
//      return currentDealer.firstName !== previousDealer.firstName;
const fieldsAreSame = Object.keys(this.filterOptions).every(field => {
        if (this.filterOptions[field]) {
          if (field === 'email') {
        return currentDealer.digitalContactInfo.email === previousDealer.digitalContactInfo.email;
      } else if (field === 'OfficeNumber') {
        return currentDealer.digitalContactInfo.workNumber === previousDealer.digitalContactInfo.workNumber;
      }else if (field === 'primaryContact') {
        return currentDealer.firstName === previousDealer.firstName && currentDealer.middleName === previousDealer.middleName && currentDealer.lastName === previousDealer.lastName
      } 
      else {
        return currentDealer[field] === previousDealer[field];
      }
        }
        return true;
      });
      // If any of the selected fields differ, return true to apply the border
      return !fieldsAreSame;
  },
  isActiveRoute(route) {
      return this.$route.path === route
    },
retrieveData: function () {
      httpcommon
        .get("/userrole/")
        .then((response) => {
          this.userroles = response.data
        })
        .catch((e) => {
          console.log(e);
          this.errorslist.push(e);
        });
      httpcommon
        .get("/staticdata/status/")
        .then((response) => {
          this.status = response.data
        })
        .catch((e) => {
          this.errorslist.push(e)
        });
    },
    myFunction() {
      var elmnt = document.getElementById("height2");
      var elmnt1 = document.getElementById("height3");
      var txt = elmnt.offsetHeight;
      var width = elmnt.offsetWidth;
      var txt1 = elmnt1.offsetHeight;
      var ht = txt + txt1;
      $("#employee").css("margin-top", txt + txt1 + 3);
    },
    menuheight () {
      var elmnt = document.getElementById("height2");
      var txt = elmnt.offsetHeight;
      $('#height3').css('margin-top', txt)
    }
},
created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  },
  mounted () {
    this.myFunction()
    this.menuheight()
    this.getDealerList()
  },
  beforeDestroy () {
    // document.removeEventListener('click', this.handleClickOutside)
  }
}
</script>
<style scoped >
.searchBlock {
  background-color: #F2F9FF;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  width: 100%;
}
.searchBlock h3 {
  font-weight: 600;
  color: #000000;
  line-height: 37.24px;
}
.searchBlock label {
  font: 400;
  font-size: 14px;
  color: #1C1B1F;
}
.searchBlock input {
  font: 400;
  font-size: 16px;
  color: #1C1B1F;
  border: 1px solid #E4ECF4;
  border-radius: 8px;
  padding: 10px;
  height: 44px;
  width: 100%;
}
/* .searchBlock input::placeholder {
color: #C5C5C5;
} */
.searchBlock button {
  border-radius: 8px;
  color: #FFFFFF;
  font-weight: 600;
  font-size: 18px;
  background-color: #1E90FF;
  padding: 10px;
  height: 44px;
  width: 160px;
  border: none;
  width: 100%;
}
.btncontainer {
  padding-top: 30px;
}
 button:disabled {
  background-color: #9B9B9B !important;
  /* color: #000000; */
  /* cursor: none; */
}
.clearText {
  text-align: start;
  /* padding-right: 25px; */
  margin: 0;
}
.clearText a {
  cursor: pointer;
  color: #91a7bd ;
  font-weight: 400;
  font-size: 13px;
  text-decoration: underline;
}
.clearText a:hover {
  
  color: #1e90ff;
}
.tableContainer {
    width: 100%;
}
.tableContainer h3 {
  font-size: 24px;
  font-weight: 600;
  color: #000000;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.tableContainer .mergeButton {
  background: #1E90FF ;
  border-radius: 8px;
  padding: 10px;
  width: 100%;
  color: #FFFFFF;
  border: none;
  font-weight: 600;
  height: -webkit-fill-available;
}
/* .customerTable {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 32px;
  table-layout: fixed;
} */
.customerTable thead tr {
  color: #9B9B9B;
  font: 600 14px 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 32px;
}
/* .customerTable thead tr th {
    border-top: none;
} */
/* .customerTable tbody tr td {
  font-size: 14px;
  font-weight: 400;
  color: #000000;
} */
tbody tr {
  border-bottom: 1px solid #dbdbdb;
}
.customerTable .tableName {
  font-weight: 600;
  font-size: 16px;
}
.customerTable {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    line-height: 32px;
    table-layout:auto;
    width: 100%;
}
.customerTable thead tr th {
    border-top: none;
    white-space: nowrap; /* Prevent header text from wrapping */
}
.customerTable tbody tr td {
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    white-space: nowrap; /* Prevent cell text from wrapping */
}
 .second {
  white-space:wrap !important;
  word-wrap: break-word !important; /* Break long words */
  word-break: break-word !important; /* Break long words */
  overflow-wrap: break-word !important; /* Ensure the text wraps within the column */
}
@media only screen and (max-width: 768px) {
    .customerTable {
        table-layout: auto; /* Allow table to adapt to screen width */
    }
}
.dark-border {
  border-top: 2px solid #1E90FF !important; /* Adjust thickness and color as needed */
}
.customPagination ::v-deep .page-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
}
.customPagination ::v-deep .page-link {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none ;
  height: 30px;
  width: 30px;
  margin: 0;
  padding: 10px;
  font-size: 20px;
  color: #9B9B9B;
}
.customPagination ::v-deep .active .page-link {
  background-color: #005DF1;
  border-radius: 8px;
  color: #FFFFFF;
}

.pagination.customPagination ::v-deep .page-item:first-child .page-link,
.pagination.customPagination ::v-deep .page-item:last-child .page-link {
  font-size: 40px !important; /* Adjust the font size as needed */
  padding: 0 20px 10px 20px;
}
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 2;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.modal-heading {
  font-size: 14px;
}
.modal-heading::after {
  content:' ';
  height: 1px;
  background: #9B9B9B;
  width: 100%;
  display: block
}
.modal-content {
  border: #ffffff;
  background-color: #ffffff;
  padding: 36px 40px 36px 40px !important;
  width: 70vh !important;
  height: auto !important;
  max-height: 70vh;
  border-radius: 16px;
  text-align: center;
}
.modalText {
  font-size: 18px;
  font-weight: 400;
  line-height: 26.6px;
  color: #000000;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.modal-body img {
  height:70px
}
.mergeButton,.yesButton {
  background-color: #1E90FF;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  line-height: 21.28px;
  padding: 10px 20px;
  border-radius: 8px;
  /* margin: auto; */
}
.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loader {
  border: 12px solid #f3f3f3;
  border-top: 12px solid #3498db;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 2s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.notFound {
  display: flex;
  /* width: 100% !important; */
  text-align: center;
  margin: auto;
}
.navLinks {
    list-style: none;
    display: flex;
    padding-left: 0;
    justify-content: center;
}
.navLinks li {
    padding: 10px 35px 10px 0px;
}
.linkItem {
font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
font-size: 18px;
font-weight: 600;
color: #8C8C8C;
Padding:10px 30px 10px 30px;
border-radius: 8px;
}
.linkItem:hover {
    color: #FFFFFF;
    background-color: #1E90FF;
}
.navLinks .active {
color: #FFFFFF !important;
background-color: #1E90FF;
}
.filterLabel {
  padding: 7px;
  margin: 0;
  margin-top: 6px;
  color: #1C1B1F;
  font-size: 14px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.dropdownContainer {
  width: 100%;
}
@media only screen and (min-width: 1201px) {
.dropdownContainer {
  width: 90%;
}
}
.b-dropdown {
  width: 100%;
  height: 46px;
  max-height: 46px;
}
 .filterDropdown ::v-deep .dropdown-toggle  {
  border-radius: 8px !important;
  border-color: #BAC1C8;
  background-color: #FFFFFF !important;
  color: #8A8A8A;
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  text-align: start;
  padding: 0px 0px 0px 12px;
}
.filterDropdown ::v-deep .dropdown-toggle::after {
  position: absolute;
  top: 20px;
  right: 13px;
}
.filterDropdown ::v-deep .dropdown-menu {
  position: absolute;
  width: 100%;
  box-sizing: border-box;
  min-width: 18rem !important;
  border: none;
  /* border-radius: 8px; */
  box-shadow: -4px 6px 25.6px 0px #00000021;
  padding: 12px 8px 12px 8px;
  z-index: 1;
}
.filterDropdown ::v-deep .custom-control {
padding: 16px 12px 16px 12px;
}
.filterDropdown ::v-deep .custom-control-input {
  position: relative;
}
/* .filterDropdown ::v-deep .custom-control:hover {
  background-color:#dbdbdb;
} */
.filterDropdown ::v-deep .custom-control-label {
  padding-left: 16px !important;
  color: #000000;
  font-weight: 600;
  font-size: 16px;
}
.filterDropdown {
  width: 100%;
}

.dropdownToggle {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.chip {
  display: flex;
  align-items: center;
  background-color: #e1e1e1;
  border-radius: 12px;
  padding: 2px 8px;
  margin-right: 4px;
  margin-bottom: 4px;
  font-size: 10px;
  height: 20px;
  width: auto;
  max-width: 130px;
}

 .chip btn-outline-danger  {
  font-size: 12px !important;
  margin-left: 4px;
  padding: 0;
  color: #000000 !important;
  background: none !important;
  border: none;
  height: 20px !important;
}
.chip btn-outline-danger:hover {
  background-color: none !important;
}
.chip-remove:hover {
  color: #333; /* Darker color on hover */
  background-color: transparent !important; /* Ensure no background color */
  border-radius: 50%; /* Circular button */
}
.btnChip {
  background-color: transparent !important;
  color:#000000;
  border: none;
}
</style>